
define('template!companiesLinkView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (hasCompany) { ;
__p += '\n<div class="icon" title="' +
((__t = ( _.i18n('menu.companies', null, 'Companies') )) == null ? '' : __t) +
'">\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V440c0-22.1 17.9-40 40-40s40 17.9 40 40v72h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"/></svg>\n</div>\n<div class="infos">\n  <div class="name">' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'</div>\n  <div class="stats">\n    <span class="customers" title="' +
((__t = ( _.escape(customersLabel) )) == null ? '' : __t) +
'">' +
((__t = ( nbrEndUsers )) == null ? '' : __t) +
'</span>\n    <span class="sep">&middot;</span>\n    <span class="amount" title="' +
((__t = ( _.escape(amountLabel) )) == null ? '' : __t) +
'">' +
((__t = ( Number(orderAmount).toFixed(2) )) == null ? '' : __t) +
' &euro;</span>\n  </div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

